export const TUTORIEL_PAGE = 'tutoriel'
export const EMAIL_PAGE = 'email'
export const POSTAL_CODE_PAGE = 'postalCode'
export const BIRTHDATE_PAGE = 'birthdate'
export const START_PAGE = 'start'
